import { render, staticRenderFns } from "./ValueFromResource.vue?vue&type=template&id=6ca725ae&scoped=true&"
import script from "./ValueFromResource.vue?vue&type=script&lang=js&"
export * from "./ValueFromResource.vue?vue&type=script&lang=js&"
import style0 from "./ValueFromResource.vue?vue&type=style&index=0&id=6ca725ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca725ae",
  null
  
)

export default component.exports